// utils/mexicoDepartmentConfig.js - Mexico Department Configuration

export const mexicoDepartmentConfig = {

    'presidencia': {
      departmentInfo: {
        name: 'Presidencia de la República',
        image: '/mexico-presidencia.svg',
        officialURL: 'https://www.gob.mx/presidencia',
        missionStatement: 'The Presidency of Mexico provides leadership and direction to the Government of Mexico.',
        route: '/mexico/presidencia',
        urlKey: 'presidencia'
      },
      mainFeeds: [
        {
          id: 'president',
          name: 'President Newsroom',
          apiParams: '&skip=0&schema=mexico&table=presidente&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-gobernacion': {
      departmentInfo: {
        name: 'Secretaría de Gobernación',
        image: '/mexico-segob.svg',
        officialURL: 'https://www.gob.mx/segob',
        missionStatement: 'The Ministry of the Interior manages internal political affairs and coordinates government activities.',
        route: '/mexico/secretaria-gobernacion',
        urlKey: 'secretaria-gobernacion'
      },
      mainFeeds: [
        {
          id: 'segob',
          name: 'Secretaría de Gobernación',
          apiParams: '&skip=0&schema=mexico&table=segob&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'N/A',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-relaciones-exteriores': {
      departmentInfo: {
        name: 'Secretaría de Relaciones Exteriores',
        image: '/mexico-sre.svg',
        officialURL: 'https://www.gob.mx/sre',
        missionStatement: 'The Ministry of Foreign Affairs manages Mexico\'s diplomatic relations and international cooperation.',
        route: '/mexico/secretaria-relaciones-exteriores',
        urlKey: 'secretaria-relaciones-exteriores'
      },
      mainFeeds: [
        {
          id: 'sre',
          name: 'Secretaría de Relaciones Exteriores',
          apiParams: '&skip=0&schema=mexico&table=sre&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Foreign Affairs',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-hacienda': {
      departmentInfo: {
        name: 'Secretaría de Hacienda y Crédito Público',
        image: '/mexico-shcp.svg',
        officialURL: 'https://www.gob.mx/shcp',
        missionStatement: 'The Ministry of Finance and Public Credit manages Mexico\'s fiscal policy and public finances.',
        route: '/mexico/secretaria-hacienda',
        urlKey: 'secretaria-hacienda'
      },
      mainFeeds: [
        {
          id: 'shcp',
          name: 'Secretaría de Hacienda y Crédito Público',
          apiParams: '&skip=0&schema=mexico&table=shcp&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-defensa': {
      departmentInfo: {
        name: 'Secretaría de la Defensa Nacional',
        image: '/mexico-sedena.svg',
        officialURL: 'https://www.gob.mx/sedena',
        missionStatement: 'The Ministry of National Defense ensures Mexico\'s national security and territorial integrity.',
        route: '/mexico/secretaria-defensa',
        urlKey: 'secretaria-defensa'
      },
      mainFeeds: [
        {
          id: 'sedena',
          name: 'Secretaría de la Defensa Nacional',
          apiParams: '&skip=0&schema=mexico&table=sedena&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Defense',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-marina': {
      departmentInfo: {
        name: 'Secretaría de Marina',
        image: '/mexico-semar.svg',
        officialURL: 'https://www.gob.mx/semar',
        missionStatement: 'The Ministry of the Navy protects Mexico\'s maritime territory and coastal areas.',
        route: '/mexico/secretaria-marina',
        urlKey: 'secretaria-marina'
      },
      mainFeeds: [
        {
          id: 'semar',
          name: 'Secretaría de Marina',
          apiParams: '&skip=0&schema=mexico&table=semar&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Defense',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-seguridad': {
      departmentInfo: {
        name: 'Secretaría de Seguridad y Protección Ciudadana',
        image: '/mexico-sspc.svg',
        officialURL: 'https://www.gob.mx/sspc',
        missionStatement: 'The Ministry of Security and Citizen Protection ensures public safety and crime prevention.',
        route: '/mexico/secretaria-seguridad',
        urlKey: 'secretaria-seguridad'
      },
      mainFeeds: [
        {
          id: 'sspc',
          name: 'Secretaría de Seguridad y Protección Ciudadana',
          apiParams: '&skip=0&schema=mexico&table=sspc&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Justice',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-economia': {
      departmentInfo: {
        name: 'Secretaría de Economía',
        image: '/mexico-se.svg',
        officialURL: 'https://www.gob.mx/se',
        missionStatement: 'The Ministry of Economy promotes economic development and competitiveness.',
        route: '/mexico/secretaria-economia',
        urlKey: 'secretaria-economia'
      },
      mainFeeds: [
        {
          id: 'se',
          name: 'Secretaría de Economía',
          apiParams: '&skip=0&schema=mexico&table=se&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-agricultura': {
      departmentInfo: {
        name: 'Secretaría de Agricultura y Desarrollo Rural',
        image: '/mexico-agricultura.svg',
        officialURL: 'https://www.gob.mx/agricultura',
        missionStatement: 'The Ministry of Agriculture and Rural Development promotes agricultural development and food security.',
        route: '/mexico/secretaria-agricultura',
        urlKey: 'secretaria-agricultura'
      },
      mainFeeds: [
        {
          id: 'agricultura',
          name: 'Secretaría de Agricultura y Desarrollo Rural',
          apiParams: '&skip=0&schema=mexico&table=agricultura&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Environment',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-comunicaciones': {
      departmentInfo: {
        name: 'Secretaría de Comunicaciones y Transportes',
        image: '/mexico-sct.svg',
        officialURL: 'https://www.gob.mx/sct',
        missionStatement: 'The Ministry of Communications and Transportation develops transport and communication infrastructure.',
        route: '/mexico/secretaria-comunicaciones',
        urlKey: 'secretaria-comunicaciones'
      },
      mainFeeds: [
        {
          id: 'sct',
          name: 'Secretaría de Comunicaciones y Transportes',
          apiParams: '&skip=0&schema=mexico&table=sct&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Infrastructure',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-bienestar': {
      departmentInfo: {
        name: 'Secretaría de Bienestar',
        image: '/mexico-bienestar.svg',
        officialURL: 'https://www.gob.mx/bienestar',
        missionStatement: 'The Ministry of Welfare implements social programs to reduce poverty and inequality.',
        route: '/mexico/secretaria-bienestar',
        urlKey: 'secretaria-bienestar'
      },
      mainFeeds: [
        {
          id: 'welfare',
          name: 'Secretaría de Bienestar',
          apiParams: '&skip=0&schema=mexico&table=bienestar&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Health',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-salud': {
      departmentInfo: {
        name: 'Secretaría de Salud',
        image: '/mexico-salud.svg',
        officialURL: 'https://www.gob.mx/salud',
        missionStatement: 'The Ministry of Health ensures access to healthcare services and promotes public health.',
        route: '/mexico/secretaria-salud',
        urlKey: 'secretaria-salud'
      },
      mainFeeds: [
        {
          id: 'salud',
          name: 'Secretaría de Salud',
          apiParams: '&skip=0&schema=mexico&table=salud&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Health',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-trabajo': {
      departmentInfo: {
        name: 'Secretaría del Trabajo y Previsión Social',
        image: '/mexico-stps.svg',
        officialURL: 'https://www.gob.mx/stps',
        missionStatement: 'The Ministry of Labor and Social Welfare regulates labor relations and worker rights.',
        route: '/mexico/secretaria-trabajo',
        urlKey: 'secretaria-trabajo'
      },
      mainFeeds: [
        {
          id: 'stps',
          name: 'Secretaría del Trabajo y Previsión Social',
          apiParams: '&skip=0&schema=mexico&table=stps&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Health',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-medio-ambiente': {
      departmentInfo: {
        name: 'Secretaría de Medio Ambiente y Recursos Naturales',
        image: '/mexico-semarnat.svg',
        officialURL: 'https://www.gob.mx/semarnat',
        missionStatement: 'The Ministry of Environment and Natural Resources protects Mexico\'s environment and natural resources.',
        route: '/mexico/secretaria-medio-ambiente',
        urlKey: 'secretaria-medio-ambiente'
      },
      mainFeeds: [
        {
          id: 'semarNat',
          name: 'Secretaría de Medio Ambiente y Recursos Naturales',
          apiParams: '&skip=0&schema=mexico&table=semarnat&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Environment',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-funcion-publica': {
      departmentInfo: {
        name: 'Secretaría de la Función Pública',
        image: '/mexico-sfp.svg',
        officialURL: 'https://www.gob.mx/sfp',
        missionStatement: 'The Ministry of Public Function ensures government transparency and fights corruption.',
        route: '/mexico/secretaria-funcion-publica',
        urlKey: 'secretaria-funcion-publica'
      },
      mainFeeds: [
        {
          id: 'sfp',
          name: 'Secretaría de la Función Pública',
          apiParams: '&skip=0&schema=mexico&table=sfp&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Justice',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    },
  
    'secretaria-turismo': {
      departmentInfo: {
        name: 'Secretaría de Turismo',
        image: '/mexico-sectur.svg',
        officialURL: 'https://www.gob.mx/sectur',
        missionStatement: 'The Ministry of Tourism promotes Mexico\'s tourism industry and sustainable tourism development.',
        route: '/mexico/secretaria-turismo',
        urlKey: 'secretaria-turismo'
      },
      mainFeeds: [
        {
          id: 'sectur',
          name: 'Secretaría de Turismo',
          apiParams: '&skip=0&schema=mexico&table=sectur&order_by=created_at',
          feedBranch: 'Executive',
          feedTopic: 'Economy',
          buttonName: 'Doc',
          type: 'main'
        }
      ],
      agencies: []
    }
  
  };
  
  // URL to config key mapping for Mexico
  const mexicoUrlToConfigMapping = {
    'presidencia': 'presidencia',
    'secretaria-gobernacion': 'secretaria-gobernacion',
    'secretaria-relaciones-exteriores': 'secretaria-relaciones-exteriores',
    'secretaria-hacienda': 'secretaria-hacienda',
    'secretaria-defensa': 'secretaria-defensa',
    'secretaria-marina': 'secretaria-marina',
    'secretaria-seguridad': 'secretaria-seguridad',
    'secretaria-economia': 'secretaria-economia',
    'secretaria-agricultura': 'secretaria-agricultura',
    'secretaria-comunicaciones': 'secretaria-comunicaciones',
    'secretaria-bienestar': 'secretaria-bienestar',
    'secretaria-salud': 'secretaria-salud',
    'secretaria-trabajo': 'secretaria-trabajo',
    'secretaria-medio-ambiente': 'secretaria-medio-ambiente',
    'secretaria-funcion-publica': 'secretaria-funcion-publica',
    'secretaria-turismo': 'secretaria-turismo'
  };
  
  // Helper functions
  export const getMexicoDepartmentConfig = (departmentKey) => {
    const configKey = mexicoUrlToConfigMapping[departmentKey] || departmentKey;
    const result = mexicoDepartmentConfig[configKey] || null;
    // console.log(`getMexicoDepartmentConfig: ${departmentKey} -> ${configKey} -> ${result ? 'FOUND' : 'NOT FOUND'}`);
    return result;
  };
  
  export const getMexicoDepartmentMainFeeds = (departmentKey) => {
    const dept = getMexicoDepartmentConfig(departmentKey);
    const mainFeeds = dept ? dept.mainFeeds : [];
    // console.log(`getMexicoDepartmentMainFeeds: ${departmentKey} -> ${mainFeeds.length} main feeds`);
    return mainFeeds;
  };
  
  export const getMexicoDepartmentAgencies = (departmentKey) => {
    const dept = getMexicoDepartmentConfig(departmentKey);
    const agencies = dept ? dept.agencies : [];
    // console.log(`getMexicoDepartmentAgencies: ${departmentKey} -> ${agencies.length} agencies`);
    return agencies;
  };
  
  export const transformMexicoAgencyToFeed = (agency) => {
    return {
      id: agency.id,
      name: agency.name,
      displayType: 'normal',
      apiParams: agency.apiParams,
      feedBranch: 'Executive',
      feedTopic: agency.topic,
      buttonName: agency.buttonName || 'Doc'
    };
  };
  
  export default mexicoDepartmentConfig;